export default {
    path: '/login',
    name: 'login',
    component: () => import('../views/Global/LoginView.vue'),
    meta: {
        title: 'LOGIN',
    },
};
